module.exports = __webpack_public_path__ + "img/koshelek.b6808294.svg";